module.exports = __webpack_public_path__ + "static/media/12@1280w.da5b4899.jpg";